import { MiddlewareAPIResponse } from '../../middlewareapiresponse';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { GetBannerPlaylistToneDto } from '../../../dto/getplaylist/getbannerplaylisttonedto';

export interface GetPlaylistResponse extends MiddlewareAPIResponse
{
    getGetPlaylistDto(): GetBannerPlaylistToneDto[];
}

export class GetPlaylistResponseDtoImpl extends MiddlewareDtoImpl implements GetPlaylistResponse
{
    private getPlaylistRespnoseDto : GetBannerPlaylistToneDto[];

    getGetPlaylistDto(): GetBannerPlaylistToneDto[]
    {
        return this.getPlaylistRespnoseDto;
    }
    setPlaylistDto(getPlaylistRespnoseDto: GetBannerPlaylistToneDto[])
    {
        this.getPlaylistRespnoseDto = getPlaylistRespnoseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/getplaylist/getplaylistresponse.tsx